import { render } from "./AppPopover.vue?vue&type=template&id=9c6b8772&scoped=true&ts=true"
import script from "./AppPopover.vue?vue&type=script&lang=ts"
export * from "./AppPopover.vue?vue&type=script&lang=ts"

import "./AppPopover.vue?vue&type=style&index=0&id=9c6b8772&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c6b8772"]])

export default __exports__